import AppDatePicker from "@/components/AppDatePicker";
import AppTextField from "@/components/AppTextField";
import FormItem from "@/components/FormItem";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import { toDateString } from "@/utils/dateUtils";
import { getDefaultBirthday } from "@/utils/utils";
import { Box, MenuItem, Stack, styled } from "@mui/material";
import { useFormik } from "formik";
import lodash from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// import classes from "../";
import NationSelect from "@/components/NationSelect";
import RpIcon from "@/components/RpIcon.jsx";
import { KYC_STATUS } from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

const StyledAppSelect = styled(AppTextField)(({theme}) => ({
  ".iconfont": {
    position: 'absolute',
    right: '14px',
    zIndex: -1
  }
}))

function KYCPreForm({ onSuccess }) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState(null);
  const [intlNameNeed, setIntlNameNeed] = useState(false);
  const [docTypes, setDocTypes] = useState([]);

  const {loading: userLoading, user} = useSelector(
    (state) => state.user
  );
  const {countries} = useSelector((state) => state.app);

  useEffect(() => {
    if (user && countries?.length) {
      _fetchKyc();
    }
  }, [user, countries]);

  const _fetchKyc = async () => {
    const kycInfo = await axiosInstance.post(API.KYC_INFO);
    if (kycInfo) {
      if (kycInfo.nation) {
        _onCountryChange(
          countries.find((country) => country.code3 === kycInfo.nation)
        );
      }
      if (kycInfo.birthday) {
        kycInfo.birthday = moment(kycInfo.birthday).toDate();
      }
      setValues(kycInfo);
    }
  };

  let yupShape = {
    birthday: Yup.string().trim().required(t("this_field_is_required")),
    firstName: Yup.string().trim().required(t("this_field_is_required")),
    lastName: Yup.string().trim().required(t("this_field_is_required")),
    docType: Yup.string().trim().required(t("this_field_is_required")),
    docNum: Yup.string().trim().required(t("this_field_is_required")),
  };

  if (intlNameNeed) {
    yupShape = {
      ...yupShape,
      firstNameEn: Yup.string().trim().required(t("this_field_is_required")),
      lastNameEn: Yup.string().trim().required(t("this_field_is_required")),
    };
  }
  const validationSchema = Yup.object().shape(yupShape);

  const _onSave = async () => {
    if (!country?.code3) {
      // todo: 没选择国家（由于有默认选中项，理论不存在），需要提示用户
      return;
    }

    setLoading(true);
    const params = {...values, nation: country?.code3};
    // params.birthday = moment(params.birthday).toDate().getTime();
    params.birthday = toDateString(params.birthday);

    if (country?.isKycNameInput != 1) {
      params.firstNameEn = null;
      params.lastNameEn = null;
    }
    try {
      await axiosInstance.post(API.KYC_PRE_SAVE, params);
      onSuccess?.();
      _onNextGuideStep();
    } finally {
      setLoading(false);
    }
  };

  const _onNextGuideStep = () => {
    dispatch(getUserInfo());
    navigate({
      pathname: RouteConstant.KYC_MAIN,
      replace: true,
    });
  };

  const {
    errors,
    values,
    touched,
    setValues,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik({
    initialValues: {
      birthday: null,
      docType: "",
      docNum: "",
      firstName: "",
      lastName: "",
      firstNameEn: "",
      lastNameEn: "",
    },
    validationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: _onSave,
  });

  const _onCountryChange = (record) => {
    setCountry(record);
    setDocTypes(record?.supportDoc?.split(",") || []);

    // 所选国家需要填写英文名
    setIntlNameNeed(record?.isKycNameInput == 1);
  };

  const isFormValid = lodash.isEmpty(errors);

  if (!user) return null;

  const approved = user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED;

  return (<>
    <Box sx={{width:'100%'}}>
      <SimpleHeader />
      <Box className="container-wrap">
        <form className="form" onSubmit={handleSubmit}>
        <Stack direction="column" gap={'24px'} sx={{paddingBottom:'80px'}}>
          <div className="form-title-box">
            <p className="form-subtitle">
              {t("form_en_only")}
            </p>
          </div>
          {/*<NationAutoComplete*/}
          {/*  label={t("country_region")}*/}
          {/*  fullWidth*/}
          {/*  filter={(country) => country?.isSupportKyc === 1}*/}
          {/*  value={country}*/}
          {/*  onChange={_onCountryChange}*/}
          {/*/>*/}
          <NationSelect isBindMobile={true} selected={country} onSelect={_onCountryChange} disabled={approved} />
          <AppTextField
            disabled={approved}
            label={t("given_name")}
            fullWidth
            autoComplete="off"
            name="firstName"
            size="large"
            clearable
            variant="outlined"
            onChange={handleChange}
            onBlur={handleBlur}
            onClear={() => setFieldValue("firstName", "")}
            error={Boolean(touched.firstName && errors.firstName)}
            helperText={touched.firstName && t(errors.firstName)}
            inputProps={{
            maxLength: 20,
            }}
              value={values.firstName}
          />
          <AppTextField
            label={t("surname")}
            disabled={approved}
            fullWidth
            autoComplete="off"
            name="lastName"
            size="large"
            clearable
            variant="outlined"
            onChange={handleChange}
            onBlur={handleBlur}
            onClear={() => setFieldValue("lastName", "")}
            error={Boolean(touched.lastName && errors.lastName)}
            helperText={touched.lastName && t(errors.lastName)}
            inputProps={{
              maxLength: 20,
            }}
            value={values.lastName}
          />
          {/* intlNameNeed */}
          {intlNameNeed && (
            <>
              <AppTextField
                label={t("given_name_intl")}
                fullWidth
                disabled={approved}
                autoComplete="off"
                name="firstNameEn"
                size="large"
                clearable
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                onClear={() => setFieldValue("firstNameEn", "")}
                error={Boolean(touched.firstNameEn && errors.firstNameEn)}
                helperText={touched.firstNameEn && t(errors.firstNameEn)}
                inputProps={{
                  maxLength: 20,
                }}
                value={values.firstNameEn}
              />
              <AppTextField
                label={t("surname_intl")}
                fullWidth
                disabled={approved}
                autoComplete="off"
                name="lastNameEn"
                size="large"
                clearable
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                onClear={() => setFieldValue("lastNameEn", "")}
                error={Boolean(touched.lastNameEn && errors.lastNameEn)}
                helperText={touched.lastNameEn && t(errors.lastNameEn)}
                inputProps={{
                  maxLength: 20,
                }}
                value={values.lastNameEn}
              />
            </>
          )}

          <FormItem label={t("date_of_birth")}>
            <AppDatePicker
              sx={{width: '100%'}}
              fullWidth
              disabled={approved}
              className="AppDatePicker"
              maxDate={dayjs(getDefaultBirthday())}
              name="birthday"
              size="small"
              variant="outlined"
              onChange={(date) => setFieldValue("birthday", date)}
              onBlur={(date) => setFieldValue("birthday", date)}
              add
              value={values.birthday}
              input
              helperText={touched.birthday && t(errors.birthday)}
            />
            {/* todo: error style */}
            <div>{touched.birthday && errors.birthday}</div>
          </FormItem>

          <StyledAppSelect
            label={t("document_type")}
            fullWidth
            select
            disabled={approved}
            size="large"
            name="docType"
            variant="outlined"
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(touched.docType && errors.docType)}
            value={values.docType}
            SelectProps={{
              IconComponent: () => <RpIcon icon={'arrow-down-simple'} size={20} />
            }}
            helperText={touched.docType && t(errors.docType)}
          >
            {docTypes.map((docType, idx) => (
              <MenuItem key={idx} value={docType}>
                {t(docType)}
              </MenuItem>
            ))}
          </StyledAppSelect>

          <AppTextField
            label={t("document_number")}
            fullWidth
            disabled={approved}
            autoComplete="off"
            name="docNum"
            size="large"
            clearable
            variant="outlined"
            onChange={handleChange}
            onBlur={handleBlur}
            onClear={() => setFieldValue("docNum", "")}
            error={Boolean(touched.docNum && errors.docNum)}
            helperText={touched.docNum && t(errors.docNum)}
            value={values.docNum}
          />

          {!approved && <Box className={"fixed-button"}>
            <AppLoadingButton
              type="submit"
              fullWidth
              loading={userLoading["getUserInfo"] || loading}
              size="large"
              disabled={!isFormValid}
              variant="contained"
            >
              {t("submit")}
            </AppLoadingButton>
          </Box>}
        </Stack>
      </form>
      </Box>
    </Box>
  </>);
}

export default KYCPreForm;
